"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFile = exports.generateCSSTypoRootFile = exports.generateCSSThemeModuleFile = exports.generateCSSThemeRootFile = exports.generateCommonFile = void 0;
var utils_1 = require("../utils");
var generateCommonFile = function (name, extension, content) {
    return {
        file: "".concat(name, ".").concat(extension),
        content: content,
    };
};
exports.generateCommonFile = generateCommonFile;
var generateCSSThemeRootFile = function (name, content) {
    return {
        file: "".concat(name, ".css"),
        content: "".concat((0, utils_1.jsToCss)(content, ':root'), "\n"),
    };
};
exports.generateCSSThemeRootFile = generateCSSThemeRootFile;
var generateCSSThemeModuleFile = function (name, content) {
    return {
        file: "".concat(name, ".css"),
        content: "".concat([(0, utils_1.jsToCss)(content, '.dark'), (0, utils_1.jsToCss)(content, '.light')].join('\n'), "\n"),
    };
};
exports.generateCSSThemeModuleFile = generateCSSThemeModuleFile;
var generateCSSTypoRootFile = function (name, content) {
    return {
        file: "".concat(name, ".typo.css"),
        content: "\n".concat(content.filter(Boolean).join('\n\n'), "\n"),
    };
};
exports.generateCSSTypoRootFile = generateCSSTypoRootFile;
/**
 * Создает дескриптор на файл с определенным именем и контентом.
 */
var generateFile = function (name, content, deprecated) {
    if (deprecated === void 0) { deprecated = ''; }
    if (typeof content !== 'string') {
        content = JSON.stringify(content, null, 4);
    }
    return {
        file: "".concat(name, ".ts"),
        content: "export const ".concat(name, " = ").concat(content, ";").concat(deprecated, "\n"),
    };
};
exports.generateFile = generateFile;
//# sourceMappingURL=generateFile.js.map